__turbopack_context__.v({
  "roomNameWrapper": "jSt0_G_roomNameWrapper",
  "tagWrapper": "jSt0_G_tagWrapper",
});
